import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { EvaluationSampleCreate } from '@frontend/types';

import {
  createEvaluationSample,
  deleteEvaluationSample,
  getEvaluationSamples,
  updateEvaluationSample,
} from '../services/specialized-agent';

export function useGetEvaluationSamples(instanceId: string, agentId: string, enabled = true) {
  return useQuery({
    queryKey: getEvaluationSamples.key(instanceId, agentId),
    queryFn: getEvaluationSamples(instanceId, agentId),
    enabled: enabled && !!instanceId && !!agentId,
  });
}

export function useCreateEvaluationSample(instanceId: string, agentId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: EvaluationSampleCreate) =>
      createEvaluationSample(instanceId, agentId, data)(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getEvaluationSamples.key(instanceId, agentId),
      });
    },
  });
}

export function useUpdateEvaluationSample(instanceId: string, agentId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ sampleId, data }: { sampleId: string; data: EvaluationSampleCreate }) =>
      updateEvaluationSample(instanceId, agentId, sampleId, data)(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getEvaluationSamples.key(instanceId, agentId),
      });
    },
  });
}

export function useDeleteEvaluationSample(instanceId: string, agentId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (sampleId: string) => deleteEvaluationSample(instanceId, agentId, sampleId)(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getEvaluationSamples.key(instanceId, agentId),
      });
    },
  });
}
